import React, { useState } from 'react';
import './header.css';
import { MenuHamburgerIcon, XMarkIcon } from '@navikt/aksel-icons';
import { Dropdown } from '@digdir/designsystemet-react';
import '@digdir/designsystemet-css';
import '@brreg/designsystemet-theme/css/brreg.css';

const renderMenuItems = (menuItems: any[]) => {
	return menuItems.map((item, index) => {
		return (
			<Dropdown.Item key={index}>
				<Dropdown.Button
					role="link"
					onClick={() => (location.href = item.url)}
				>
					{item.text}
				</Dropdown.Button>
			</Dropdown.Item>
		);
	});
};

export const Header = ({
	logoImageSvgData,
	menuItems,
}: {
	logoImageSvgData: string;
	menuItems: any[];
}) => {
	const [open, setOpen] = useState(false);

	return (
		<header>
			<section>
				<div className="logo-block">
					<a
						href="/"
						className="logo ds-link"
						dangerouslySetInnerHTML={{ __html: logoImageSvgData }}
					></a>
					<div className="slogan slogan-top">
						Velkommen til din nye jobb
					</div>
				</div>
				<Dropdown.TriggerContext>
					<Dropdown.Trigger onClick={() => setOpen(!open)}>
						{open ? (
							<XMarkIcon
								role="none"
								aria-hidden="true"
								fontSize="1.5rem"
							/>
						) : (
							<MenuHamburgerIcon
								role="none"
								aria-hidden="true"
								fontSize="1.5rem"
							/>
						)}
						Meny
					</Dropdown.Trigger>
					<Dropdown open={open} onClose={() => setOpen(false)}>
						<Dropdown.List>
							{renderMenuItems(menuItems)}
						</Dropdown.List>
					</Dropdown>
				</Dropdown.TriggerContext>
			</section>
			<div className="slogan slogan-below">
				Velkommen til din nye jobb
			</div>
		</header>
	);
};
